module.exports = __webpack_public_path__ + "static/media/garrett.e43e5d0f.jpg";